// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  pollingId: __t.u64().primaryKey().name("polling_id"),
  endpointId: __t.u64().name("endpoint_id"),
  level: __t.string(),
  message: __t.string(),
  statusCode: __t.u32().name("status_code"),
  createdAt: __t.timestamp().name("created_at"),
});
